module.exports = __webpack_public_path__ + "img/button-buy.5e389884.png";